import { TranslateService } from '@project/translate';

/**
 * @description
 * Enum that represents the medical referral types returned by the backend.
 * IMPORTANT:
 * - Backend may return "default", which must be treated as "forwarding".
 */

export enum EMedicalReferralType {
  Forwarding = 'Forwarding',
  Default = 'Default',
  Return = 'Return',
  FollowUp = 'FollowUp',
  Fitting = 'Fitting',
  Exam = 'Exam',
}
export function getMedicalReferralTypeLabel(type: EMedicalReferralType | string): string | undefined {
  const normalizedType =
    type === EMedicalReferralType.Default ? EMedicalReferralType.Forwarding : (type as EMedicalReferralType);

  const map: Record<EMedicalReferralType, () => string> = {
    [EMedicalReferralType.Forwarding]: () => TranslateService.localize('sadt.medical-referral-type.forwarding'),

    [EMedicalReferralType.Default]: () => TranslateService.localize('sadt.medical-referral-type.forwarding'),

    [EMedicalReferralType.Return]: () => TranslateService.localize('sadt.medical-referral-type.return'),

    [EMedicalReferralType.FollowUp]: () => TranslateService.localize('sadt.medical-referral-type.follow-up'),

    [EMedicalReferralType.Fitting]: () => TranslateService.localize('sadt.medical-referral-type.fitting'),

    [EMedicalReferralType.Exam]: () => TranslateService.localize('sadt.medical-referral-type.exam'),
  };

  return map[normalizedType]?.();
}
